import { BackButton, Button, Modal, Title } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { ReduxState } from '@spa/redux/ReduxState'
import type { FC } from 'react'
import { useSelector } from 'react-redux'

import RestSummary from '../../RestFormSection/components/RestSummary'
import type { RestFormData } from '../../hooks'
import { CreationWillDeleteShifts } from '../Alerts'

type Props = {
  selectedContracts: string[]
  onSubmit: Function
  onCancel: Function
  formData: RestFormData
  restType: string
  isEdit?: boolean
}

export const FormConfirmation: FC<Props> = ({
  selectedContracts,
  onCancel,
  onSubmit,
  formData,
  restType,
  isEdit
}) => {
  const { t, tCommon } = usePlanningFormTranslation()
  const contracts = useSelector((state: ReduxState) =>
    state.contracts.get('data')
  )

  return (
    <>
      <Modal.Content>
        <Title size={4}>
          {isEdit
            ? t('restForm.restConfirmEditTitle')
            : t('restForm.restConfirmCreateTitle')}
        </Title>
        <BackButton
          size='s'
          onClick={() => onCancel()}
          data-testid='button-back'
          className='my-4'
        >
          {tCommon('action.back')}
        </BackButton>
        <RestSummary restType={restType} {...formData} />
        {Boolean(selectedContracts?.length) && (
          <CreationWillDeleteShifts
            contracts={contracts}
            selectedContracts={selectedContracts}
          />
        )}
      </Modal.Content>
      <Modal.Footer>
        <Button fillWidth onClick={() => onSubmit()}>
          {t('common.app:action.confirm')}
        </Button>
      </Modal.Footer>
    </>
  )
}
